import React from 'react'
import { ConfirmationDialog } from '../../../legacy-design-system/modal'
import { FormattedMessage } from 'react-intl'

interface Props {
  readonly isOpen: boolean
  readonly count: number
  readonly onConfirm: () => void
  readonly onCancel: () => void
}

export function DeleteDialog({ isOpen, count, onConfirm, onCancel }: Props) {
  return (
    <ConfirmationDialog
      size="small"
      isOpen={isOpen}
      renderBody={() => (
        <FormattedMessage
          values={{ count }}
          id="plural_vulnerabilities_deleteVulnsConfirmation"
        />
      )}
      renderCancelMessage={() => <FormattedMessage id="action_cancel" />}
      renderTitle={() => (
        <FormattedMessage
          values={{ count }}
          id="title_deleteVulnerabilityPlural"
        />
      )}
      renderConfirmMessage={() => <FormattedMessage id="action_delete" />}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  )
}
